import { Observable } from 'rxjs';
import { IPilot, IPilotAdmin, IPilotOverride } from '../../pilotpay/pay-scales/pay-scales.types';
import { Injectable } from '@angular/core';
import { PilotPayHttpClient } from '../../core';

@Injectable()
export class PilotsService {
	constructor(private http: PilotPayHttpClient) {}
	public getPilot(employeeId: number, includePayScale: boolean = false, date?: string): Observable<IPilot> {
		return this.http.getRequest(`/api/pilots/${employeeId}?includePayScale=${includePayScale}&date=${date}`);
	}

	public getPilots(includePayScale: boolean = false): Observable<IPilot[]> {
		return this.http.getRequest(`/api/pilots?includePayScale=${includePayScale}`);
	}

	public exportToPayroll(payload: number[], payrollEnd: boolean): Observable<Blob> {
		return this.http.postRequest(`/api/pilots/export/${payrollEnd}`, payload, true);
	}

	public getPilotsWithTimeSheetData(date: string): Observable<IPilot[]> {
		return this.http.getRequest(`/api/pilots/all?date=${date}`);
	}

	public getPilotsByPayScale(payScaleId: number): Observable<IPilot[]> {
		return this.http.getRequest(`/api/pilots/pay-scales/${payScaleId}`);
	}

	public getPilotsWithAdminData(): Observable<IPilotAdmin[]> {
		return this.http.getRequest(`/api/pilots/admins`);
	}

	public setPilotAdminStatus(employeeId: number, isAdmin: boolean): Observable<null> {
		return this.http.putRequest(`/api/pilots/set-admin/${employeeId}/${isAdmin}`, null);
	}

	public getPilotsWithOverrideData(includeFuture: boolean = false): Observable<IPilotOverride[]> {
		let url: string = '/api/pilots/override';
		if (includeFuture) {
			url += `?includeFuture=${includeFuture}`;
		}
		return this.http.getRequest(url);
	}

	public overridePilotData(employeeId: number, payload: IPilotOverride): Observable<IPilotOverride> {
		return this.http.putRequest(`/api/pilots/${employeeId}`, payload);
	}

	public deleteOverridePilotData(employeeId: number, date: string): Observable<null> {
		return this.http.deleteRequest(`/api/pilots/${employeeId}/scheduled-override?date=${date}`);
	}
}
